import React, { useState, useEffect } from 'react';
import '../styles/DarkThemeToggle.css';

const DarkThemeToggle = () => {
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    // Check for saved theme preference or default to dark mode
    const savedTheme = localStorage.getItem('darkMode');
    if (savedTheme) {
      setIsDarkMode(savedTheme === 'true');
      document.body.setAttribute('data-theme', savedTheme === 'true' ? 'dark' : 'light');
    } else {
      document.body.setAttribute('data-theme', 'dark');
    }
  }, []);

  const toggleTheme = () => {
    const newTheme = !isDarkMode;
    setIsDarkMode(newTheme);
    document.body.setAttribute('data-theme', newTheme ? 'dark' : 'light');
    localStorage.setItem('darkMode', newTheme.toString());
  };

  return (
    <div className="dark-theme-toggle">
      <button 
        className={`theme-toggle-btn ${isDarkMode ? 'dark' : 'light'}`}
        onClick={toggleTheme}
        aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`}
      >
        <div className="toggle-icon">
          {isDarkMode ? (
            <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" fill="currentColor"/>
            </svg>
          ) : (
            <svg width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <clipPath id="half">
                  <rect x="0" y="0" width="12" height="24"/>
                </clipPath>
              </defs>
              <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth="1.5"/>
              <circle cx="12" cy="12" r="9" fill="currentColor" clipPath="url(#half)"/>
            </svg>
          )}
        </div>
      </button>
    </div>
  );
};

export default DarkThemeToggle;